<div class="card mt-4">
  <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
</div>

<div class="card mt-4">
  <div class="font-semibold text-xl mb-4">Historique des Envois</div>

  <div class="filter-container">


      <p-multiSelect
        [options]="dateOptions"
        [(ngModel)]="selectedDates"
        (onChange)="onFilterChange()"
        placeholder="Filtré par date"
        display="chip"
      ></p-multiSelect>

      <p-multiSelect
        [options]="doOptions"
        [(ngModel)]="selectedDo"
        (onChange)="onFilterChange()"
        placeholder="Filtré par DO"
        display="chip"
      ></p-multiSelect>

      <p-multiSelect
        [options]="statusOptions"
        [(ngModel)]="selectedStatus"
        (onChange)="onFilterChange()"
        placeholder="Filtré par statuts"
        display="chip"
      ></p-multiSelect>
  </div>

  <div class="stats-container">
    <div *ngIf="isLoading" class="loading-state">
      <p-progressSpinner></p-progressSpinner>
      <span>Chargement des statistiques...</span>
    </div>

    <div *ngIf="!isLoading" class="stats-display">
      <div class="stat-item">
        <div class="progress-circle">
          <svg>
            <circle class="bg" cx="50" cy="50" r="45"></circle>
            <circle
              class="progress"
              cx="50" cy="50" r="45"
              [style.strokeDashoffset]="getOffset(stats.totalReports)"
            ></circle>
          </svg>
          <div class="progress-value">{{ stats.totalReports }}</div>
        </div>
        <div class="stat-label">TOTAL RAPPORTS</div>
        <div class="stat-description">Nombre total des rapports</div>
      </div>

      <div class="stat-item">
        <div class="progress-circle cyan">
          <svg>
            <circle class="bg" cx="50" cy="50" r="45"></circle>
            <circle
              class="progress"
              cx="50" cy="50" r="45"
              [style.strokeDashoffset]="getOffset(stats.totalAvecDossier)"
            ></circle>
          </svg>
          <div class="progress-value">{{ stats.totalAvecDossier }}</div>
        </div>
        <div class="stat-label">TOTAL AVEC DOSSIER</div>
        <div class="stat-description">Rapports avec un dossier</div>
      </div>

      <div class="stat-item">
        <div class="progress-circle pink">
          <svg>
            <circle class="bg" cx="50" cy="50" r="45"></circle>
            <circle
              class="progress"
              cx="50" cy="50" r="45"
              [style.strokeDashoffset]="getOffset(stats.totalSansDossier)"
            ></circle>
          </svg>
          <div class="progress-value">{{ stats.totalSansDossier }}</div>
        </div>
        <div class="stat-label">TOTAL SANS DOSSIER</div>
        <div class="stat-description">Rapports sans dossier</div>
      </div>
    </div>
  </div>

  <p-table
    [value]="filteredLogs"
    [loading]="isLoading"
    styleClass="p-datatable-striped p-datatable-gridlines"
    [paginator]="true"
    [rowHover]="true"
    [showGridlines]="true"
    [rows]="10"
    stripedRows
    [tableStyle]="{ 'min-width': '75rem' }"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
    [rowsPerPageOptions]="[10, 20, 30, 40, 50,60,70,80,90,100]"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Date</th>
        <th>Heure</th>
        <th>DO</th>
        <th>Nb Rapports</th>
        <th>Statut</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-log>
      <tr>
        <td>{{ log.JOUR }}</td>
        <td>{{ log.TIME }}</td>
        <td>{{ log.DO }}</td>
        <td>{{ log.NB_RAPPORTS }}</td>
        <td>
          <p-tag
            [value]="log.COMPLET"
            [severity]="getStatusSeverity(log.COMPLET)">
          </p-tag>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Aucune donnée disponible</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-toast></p-toast>




  <!-- Section de sélection de table
  <div class="w-full md:w-1/3 mb-6">
    <h3 class="font-semibold text-xl mb-4 text-center">Liste des Tables</h3>

    <div class="filter-card border border-gray-300 rounded-md p-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Sélectionnez une table
      </label>

      <p-dropdown
        [options]="filteredTableList"
        [(ngModel)]="selectedTable"
        [filter]="true"
        optionValue="value"
        filterPlaceholder="Rechercher une table..."
        placeholder="Sélectionner une table"
        optionLabel="label"
        class="w-full text-sm mb-4">
        <ng-template let-option pTemplate="item">
          <div class="flex items-center text-sm">
            <i class="pi pi-table mr-2 text-xs"></i>
            <span>{{ option.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

   Boutons en dessous de la table -->
  <!-- <div class="w-full md:w-1/3 mt-4">
    <div class="flex justify-between gap-2">
      <button pButton type="button" label="Prévisualiser" icon="pi pi-eye"
              class="p-button-sm w-full" (click)="onPreview()"
              [disabled]="!selectedTable"></button>

      <button pButton type="button" label="Extraire" icon="pi pi-download"
              class="p-button-sm w-full" (click)="onExtract()"
              [disabled]="!selectedTable"></button>
    </div>
  </div>

<br><br> -->
    <!-- Section de prévisualisation
  <div class="w-full mb-6" *ngIf="selectedTable">
    <h4 class="text-lg font-semibold mb-3 text-center">Prévisualisation</h4>
    <div class="border border-gray-200 rounded-lg overflow-hidden">
        <p-table [value]="previewData" [loading]="loadingPreview"
                [scrollable]="true" scrollHeight="400px"
                [responsive]="true" styleClass="p-datatable-striped p-datatable-gridlines">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let col of previewColumns" class="text-center whitespace-nowrap p-2">
                {{col}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td *ngFor="let col of previewColumns" class="text-center p-2 whitespace-nowrap">
                {{rowData[col] || 'null'}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="loading">
            <tr>
              <td [attr.colspan]="previewColumns.length" class="text-center p-4">
                Chargement des données...
              </td>
            </tr>
          </ng-template>
        </p-table>
    </div>
  </div> -->
